import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取分销提现列表
export function listAffiliateWithdrawal(params) {
  return new Promise((resolve, reject) => {
    params.shopId = getShopId()
    request({
      url: '/affiliateWithdrawal.listAffiliateWithdrawal',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核分销提现
export function auditAffiliateWithdrawal(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/affiliateWithdrawal.auditAffiliateWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除分销提现
export function deleteAffiliateWithdrawal(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/affiliateWithdrawal.deleteAffiliateWithdrawal',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}